/* Hero slider — Odd Ritual-pattern behaviour, dependency-free.
   - clip-path wipe top→bottom between slides + image parallax (Web Animations API)
   - numbered nav: hover previews the slide's thumbnail and darkens the stage
   - no autoplay: slides change on click/swipe only, like the reference
   Registry-managed: re-inits after every Barba swap; all listeners carry the
   page's abort signal so re-running is always safe (never double-binds). */
(function () {
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var WIPE_MS = 1000;
  var THUMB_MS = 600;

  var FULL = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
  var TOP_EDGE = 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)';
  var BOTTOM_EDGE = 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)';

  function init(ctx) {
    var signal = ctx && ctx.signal;

    document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
      var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-hero-nav]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
      var scrollBtn = root.querySelector('[data-hero-scroll]');
      var nextBtn = root.querySelector('[data-hero-next]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var activeIndex = 0;
      root.classList.add('is-ready');
      var running = [];

      function cancelRunning() {
        running.forEach(function (a) { a.cancel(); });
        running = [];
        slides.forEach(function (slide) { slide.style.zIndex = ''; });
      }

      function setClasses(nextIndex) {
        navItems.forEach(function (item, i) {
          item.classList.toggle('is-active', i === nextIndex);
          item.setAttribute('aria-selected', i === nextIndex ? 'true' : 'false');
          item.tabIndex = i === nextIndex ? 0 : -1;
        });
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === nextIndex);
          if (i === nextIndex) {
            slide.removeAttribute('aria-hidden');
            slide.inert = false;
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.inert = true;
          }
        });
      }

      function moveSlide(nextIndex, forwards) {
        if (nextIndex === activeIndex) return;

        // interrupt any wipe in progress: snap it to its resting state (the
        // is-active classes define that look) and start the new one right away
        cancelRunning();

        var prev = slides[activeIndex];
        var next = slides[nextIndex];
        var prevImg = prev.querySelector('[data-hero-img]');
        var nextImg = next.querySelector('[data-hero-img]');

        setClasses(nextIndex);
        activeIndex = nextIndex;

        if (reduceMotion) return;

        prev.style.zIndex = '1';
        next.style.zIndex = '2';

        var opts = { duration: WIPE_MS, easing: EASE };
        var anims = [];

        if (forwards) {
          anims.push(next.animate([{ clipPath: TOP_EDGE }, { clipPath: FULL }], opts));
          anims.push(prev.animate([{ clipPath: FULL }, { clipPath: BOTTOM_EDGE }], opts));
          anims.push(prevImg.animate([{ transform: 'translateY(0%)' }, { transform: 'translateY(10%)' }], opts));
          anims.push(nextImg.animate([{ transform: 'translateY(-10%)' }, { transform: 'translateY(0%)' }], opts));
        } else {
          anims.push(next.animate([{ clipPath: BOTTOM_EDGE }, { clipPath: FULL }], opts));
          anims.push(prev.animate([{ clipPath: FULL }, { clipPath: TOP_EDGE }], opts));
          anims.push(prevImg.animate([{ transform: 'translateY(0%)' }, { transform: 'translateY(-10%)' }], opts));
          anims.push(nextImg.animate([{ transform: 'translateY(10%)' }, { transform: 'translateY(0%)' }], opts));
        }

        running = anims;

        Promise.all(
          anims.map(function (a) { return a.finished.catch(function () {}); })
        ).then(function () {
          // only clean up if we're still the latest batch (not interrupted)
          if (running !== anims) return;
          anims.forEach(function (a) { a.cancel(); });
          running = [];
          prev.style.zIndex = '';
          next.style.zIndex = '';
        });
      }

      function goNext() {
        moveSlide((activeIndex + 1) % slides.length, true);
      }

      /* Arrow keys follow the manual tab sequence. */
      root.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        var n = e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : (activeIndex + (e.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length;
        moveSlide(n, n > activeIndex);
        navItems[n].focus();
      }, { signal: signal });
      /* --- nav clicks --- */
      navItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var target = parseInt(item.dataset.index, 10);
          moveSlide(target, target > activeIndex);
        }, { signal: signal });

        /* --- hover: preview thumb + darken stage --- */
        var thumb = item.querySelector('[data-hero-thumb]');
        var thumbMedia = thumb ? thumb.querySelector('img, .hero-slider_nav-thumb-ph') : null;

        item.addEventListener('mouseenter', function () {
          root.classList.add('is-peeking');
          if (!thumbMedia || item.classList.contains('is-active') || reduceMotion) return;
          thumbMedia.animate(
            [
              { opacity: 0, clipPath: TOP_EDGE },
              { opacity: 1, clipPath: FULL }
            ],
            { duration: THUMB_MS, easing: EASE, fill: 'forwards' }
          );
        }, { signal: signal });

        item.addEventListener('mouseleave', function () {
          root.classList.remove('is-peeking');
          if (!thumbMedia || reduceMotion) return;
          thumbMedia.animate(
            [
              { opacity: 1, clipPath: FULL },
              { opacity: 0, clipPath: BOTTOM_EDGE }
            ],
            { duration: THUMB_MS, easing: EASE, fill: 'forwards' }
          );
        }, { signal: signal });
      });

      /* --- scroll cue --- */
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function () {
          var section = root.closest('.shopify-section') || root;
          var target = section.nextElementSibling;
          if (target) {
            target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          }
        }, { signal: signal });
      }

      /* --- mobile next --- */
      if (nextBtn) {
        nextBtn.addEventListener('click', goNext, { signal: signal });
      }

      /* --- swipe --- */
      var startX = null;
      var startY = null;
      root.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button')) return;
        startX = e.clientX;
        startY = e.clientY;
      }, { signal: signal });
      root.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) < 60 || Math.abs(e.clientY - startY) > Math.abs(dx)) return;
        if (dx < 0) {
          goNext();
        } else {
          moveSlide((activeIndex - 1 + slides.length) % slides.length, false);
        }
      }, { signal: signal });
    });
  }

  if (window.Onni && window.Onni.register) {
    window.Onni.register('hero-slider', init);
  } else {
    init();
  }
})();
